import React, { Component } from 'react';
import { Col } from "reactstrap";
import data from "./data"
import uuid from "uuid/v4"


class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    getTitleFromID(id) {
        let index = data.findIndex(el => {
            return el.id === id
        });
        if (index) {
            return data[index].title;
        }
        else {
            return "Could not get title information!"
        }
    }

    render() {
        return (
            <>
                {this.props.data.navOptions.map(navID => {
                    return (
                        <Col md="4" sm="6" lg="12" className="items" onClick={() => { this.props.navTo(navID) }} key={uuid()}>
                            {navID === "7" ? <> <i className="fas fa-info-circle"></i> <br /> </> : <> <i className="fas fa-calendar-day"></i> <br /> </>}
                            {this.getTitleFromID(navID)}
                        </Col>
                    )
                })}
            </>
        );
    }
}

export default Home;